import { Component } from '@angular/core';

@Component({
  selector: 'app-process',
  imports: [],
  templateUrl: './process.html',
  styleUrl: './process.scss'
})
export class Process {

}
